import localhost from '../../utils/localhost.js';
import axios from 'axios';
import random from '../../utils/random';

const distribution = {
  state: {
    topDistributorList: null,
    commissionSystemList: null
  },
  mutations: {
    topDistributorListUpdate (state, data) {
      state.topDistributorList = data;
    },
    commissionSystemListUpdate (state, data) {
      state.commissionSystemList = data;
    },
  },
  actions: {
    getTopDistributorList ({commit}, data) {
      var params = new URLSearchParams();
      params.append('appId', data.appId);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/distributor/getTopDistributorList', params)
          .then((res) => {
            if (!res.data.success) {
              reject('获取顶层分销员列表失败');
            } else {
              commit('topDistributorListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    getCommissionSystemList ({commit}, data) {
      var params = new URLSearchParams();
      params.append('appId', data.appId);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/distributor/getCommissionSystemList', params)
          .then((res) => {
            if (!res.data.success) {
              reject('获取佣金体系列表失败');
            } else {
              commit('commissionSystemListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    setCommissionSystem ({commit}, data) {
      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/distributor/setCommissionSystem', data)
          .then((res) => {
            if (!res.data.success) {
              reject('设置佣金体系失败');
            } else {
              // commit('topDistributorListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
    getDynamicQrCode ({commit}, data) {
      var params = new URLSearchParams();
      params.append('appId', data.appId);
      params.append('page', data.page);
      params.append('qrcodeKeyword', data.qrcodeKeyword);
      params.append('scene', data.scene);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/message/getDynamicQrCode', params)
          .then((res) => {
            resolve(res.data);
          }).catch((err) => {
          reject(err);
        })
      });
    },
    searchUserFromMobile ({commit}, data) {
      var params = new URLSearchParams();
      params.append('mobile', data.mobile);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/user/findByMobile', params)
          .then((res) => {
            // if (res.data.showName) {
            //   res.data.showName = utf8ByteToUnicodeStr(res.data.showName);
            //   console.log(res.data.showName)
            // }
            resolve(res.data);
          }).catch((err) => {
          reject(err);
        })
      });
    },
    setTopDistributorBenefit ({commit}, data) {
      var params = new URLSearchParams();
      params.append('distributorId', data.distributorId);
      params.append('userId', data.userId);
      params.append('benefitPoint', data.benefitPoint);

      return new Promise(function (resolve, reject) {
        axios.post(localhost.ajaxurl + '/distributor/setTopDistributorBenefit', params)
          .then((res) => {
            if (!res.data.success) {
              reject('设置受益人信息失败');
            } else {
              // commit('topDistributorListUpdate', res.data.data);
              resolve(res.data.data);
            }
          }).catch((err) => {
          reject(err);
        })
      });
    },
  },
  getters: {}
};

export default distribution;

function utf8ByteToUnicodeStr(utf8Bytes){
  if(typeof utf8Bytes === 'string') {
    return utf8Bytes;
  }
  var unicodeStr ="";
  for (var pos = 0; pos < utf8Bytes.length;){
    var flag= utf8Bytes[pos];
    var unicode = 0 ;
    if ((flag >>>7) === 0 ) {
      unicodeStr+= String.fromCharCode(utf8Bytes[pos]);
      pos += 1;

    } else if ((flag &0xFC) === 0xFC ){
      unicode = (utf8Bytes[pos] & 0x3) << 30;
      unicode |= (utf8Bytes[pos+1] & 0x3F) << 24;
      unicode |= (utf8Bytes[pos+2] & 0x3F) << 18;
      unicode |= (utf8Bytes[pos+3] & 0x3F) << 12;
      unicode |= (utf8Bytes[pos+4] & 0x3F) << 6;
      unicode |= (utf8Bytes[pos+5] & 0x3F);
      unicodeStr+= String.fromCharCode(unicode) ;
      pos += 6;

    }else if ((flag &0xF8) === 0xF8 ){
      unicode = (utf8Bytes[pos] & 0x7) << 24;
      unicode |= (utf8Bytes[pos+1] & 0x3F) << 18;
      unicode |= (utf8Bytes[pos+2] & 0x3F) << 12;
      unicode |= (utf8Bytes[pos+3] & 0x3F) << 6;
      unicode |= (utf8Bytes[pos+4] & 0x3F);
      unicodeStr+= String.fromCharCode(unicode) ;
      pos += 5;

    } else if ((flag &0xF0) === 0xF0 ){
      unicode = (utf8Bytes[pos] & 0xF) << 18;
      unicode |= (utf8Bytes[pos+1] & 0x3F) << 12;
      unicode |= (utf8Bytes[pos+2] & 0x3F) << 6;
      unicode |= (utf8Bytes[pos+3] & 0x3F);
      unicodeStr+= String.fromCharCode(unicode) ;
      pos += 4;

    } else if ((flag &0xE0) === 0xE0 ){
      unicode = (utf8Bytes[pos] & 0x1F) << 12;;
      unicode |= (utf8Bytes[pos+1] & 0x3F) << 6;
      unicode |= (utf8Bytes[pos+2] & 0x3F);
      unicodeStr+= String.fromCharCode(unicode) ;
      pos += 3;

    } else if ((flag &0xC0) === 0xC0 ){ //110
      unicode = (utf8Bytes[pos] & 0x3F) << 6;
      unicode |= (utf8Bytes[pos+1] & 0x3F);
      unicodeStr+= String.fromCharCode(unicode) ;
      pos += 2;

    } else{
      unicodeStr+= String.fromCharCode(utf8Bytes[pos]);
      pos += 1;
    }
  }
  return unicodeStr;
}



// WEBPACK FOOTER //
// ./src/vuex/modules/distribution.js